<div class="container">

  <form #leadForm="ngForm" (submit)="submitFormData($event)" *ngIf="validApiKey()" ngNativeValidate>

    <div *ngIf="successMessage !== undefined" class="alert alert-success mt-5" role="alert">
      Lead has been successfully transferred. You can now hotkey over the lead.
    </div>
    <div *ngIf="errorMessage" class="alert alert-danger mt-5" role="alert">
      <strong>Whoops</strong> {{ errorMessage }}
    </div>
    <h3>Basic Details <small class="text-muted">(Introducer Reference and Disposable Income are required)</small></h3>
    <app-basic-details (updateCreditorCount)="updateNumberOfCreditors($event)"
                       [(formData)]="formData"></app-basic-details>

    <h3>Name, Address and Contact Details <small class="text-muted">(First Name, Last Name, Address 1, Postcode and at
      least a home OR mobile number are required)</small></h3>

    <app-contact-details [(formData)]="formData"></app-contact-details>

    <h3>Personal Information</h3>
    <app-personal-information [(formData)]="formData"></app-personal-information>

    <h3 [class.text-danger]="!creditorsEntered()">Creditors <small class="text-muted">(At least 2 creditors are
      required)</small></h3>
    <app-creditor-details (updateCreditorCount)="updateNumberOfCreditors($event)"
                          [(formData)]="formData"></app-creditor-details>

    <div *ngIf="successMessage" class="alert alert-success mt-5" role="alert">
      Lead has been successfully transferred. You can now hotkey over the lead.
    </div>
    <div *ngIf="errorMessage" class="alert alert-danger mt-5" role="alert">
      <strong>Whoops</strong> {{ errorMessage }}
    </div>

    <app-submission [formIsValid]="fullFormIsValid() && validPostcode() && sending === false"></app-submission>

  </form>

  <h1 *ngIf="!validApiKey()" class="text-center text-muted">No API Key provided</h1>

</div>



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/app.component.html